<div class="page">
  <app-page-header
    itemName=""
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
    [propertyId]="propertyId"
  >
  </app-page-header>
  <div class="page-content">

    <app-property-detail-mapping-tab [property]="propertyData" [formActiveSection]="mappingFormActiveSection"
      [formActiveSubitemId]="itemId" [condoStructure]="condoStructure"
      *ngIf="property && property.get('structure') && condoStructure">
    </app-property-detail-mapping-tab>
    <app-card-spinner [visible]="!property || (property && !property.get('structure')) || !condoStructure" type="zero">
    </app-card-spinner>

    <mat-card *ngIf="pageIsLoaded && property && !property.get('structure') && !condoStructure"
      class="mt-4 custom-card">
      <mat-card-title>{{ 'properties.detail.newStructure.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'properties.detail.newStructure.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <button mat-raised-button color="primary" (click)="onCreateStructure()">
          <mat-icon fontSet="fal" fontIcon="fa-plus-circle" class="fs-10 mr-1"></mat-icon>
          {{ 'properties.detail.newStructure.btnText' | translate }}
        </button>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->